import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import AddressProp from '../../../commonComponents/propTypes/addressProp';
import FormattedAddress from '../FormattedAddress';
import { handleShippingAddressInOrder } from '../../../services/utilityFunctions';
import UserProp from '../../../commonComponents/propTypes/userProp';
import CustomRadio from '../../../commonComponents/forms/inputs/CustomRadio';

const ShopShippingAddress =
  ({ address, editAddress, id, checked, setChecked, isShipping, removeAddress, user, orderAlreadyCreated }) => {
  const handleCheckbox = event => {
    if (isShipping && parseInt(event.target.value, 10) === parseInt(id, 10) && checked) {
      setChecked(-1);
    } else {
      setChecked(id);
    }
  };
  return (
    <li className="address-item">
      <div className="form-group row">
        <div className="col-12 col-md-9">
          <div className="col-form-label vertical-center">
            <div className="row shipping-provider-options">
              <div className={`col-2 no-padding fix-width ${orderAlreadyCreated ? 'checkout-disabled' : ''}`}>
                <CustomRadio
                  id={id}
                  value={id}
                  onChange={handleCheckbox}
                  checked={checked}
                  disabled={orderAlreadyCreated}
                />
              </div>
              <FormattedAddress
                address={handleShippingAddressInOrder(user, address)}
                showOptionalFields
                nameContainer="nameFormatted-checkout"
                addressContainer="addressFormatted-checkout"
                containerClass="col-10 fix-width-address"
                formatName
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3 button-section">
          {!orderAlreadyCreated && (
            <div className="profile-actions">
              <button
                type="button"
                className="btn btn-metal m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill custom-btn-address"
                onClick={() => editAddress(id)}
                onKeyDown={() => editAddress(id)}
                tabIndex={id}
              >
                <i className="fa fa-pen" />
              </button>
              {isShipping &&
                <button
                  type="button"
                  className="btn btn-metal m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill custom-btn-address"
                  onClick={() => removeAddress(id)}
                  onKeyDown={() => removeAddress(id)}
                  tabIndex={id}
                >
                  <i className="fa fa-trash" />
                </button>
              }
            </div>
          )}
        </div>
      </div>
    </li>
  );
};

ShopShippingAddress.propTypes = {
  address: PropTypes.shape(AddressProp.propType).isRequired,
  editAddress: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
  isShipping: PropTypes.bool,
  removeAddress: PropTypes.func,
  user: PropTypes.shape(UserProp.propType).isRequired,
  orderAlreadyCreated: PropTypes.string,
};

ShopShippingAddress.defaultProps = {
  isShipping: false,
  removeAddress: () => {},
  orderAlreadyCreated: null,
};

export default translate(ShopShippingAddress);
